import { Profile } from '@omneo/omneo-sdk'

/**
 * Returns the profile shoetag if present
 * @param {Profile} profile
 */
export const getShoeTag = (profile) => {
  const shoeTag = profile.identities.find((identity) => identity.handle === 'shoetag')
  return shoeTag ? shoeTag.identifier : ''
}
